export function dayMonth(isoDate: string): string {
  const [, month, day] = isoDate.split("-");

  return `${day}.${month}`;
}

export function fullDate(isoDate: string): string {
  const [year, month, day] = isoDate.split("-");

  return `${day}.${month}.${year}`;
}

export function weekSpan(start: string, end: string): string {
  return `${dayMonth(start)} – ${dayMonth(end)}`;
}
